<div class="pxo-main-div">
  <app-version-change-popup></app-version-change-popup>
  <app-header></app-header>
  <app-powerx class="scroll-style"></app-powerx>
</div>
